<template>
  <div v-if="lang.vcc" class="about_credit_card">
    {{ lang.vcc.SFS_LANG_ROW_8 }}<br />
    {{ lang.vcc.SFS_LANG_ROW_9 }}
    <i style="color: rgb(164, 170, 189); float: right; line-height: 10pt" class="bullet_right fa fa-chevron-right"></i>
  </div>
</template>

<script>
export default {
  name: 'AboutCreditCard'
}
</script>
